import type { ProjectSortEnum } from './components/__generated__/DirectoryViewProjectQuery.graphql';

export const DEFAULT_TABLE_PROJECT_SORTS: ProjectSortEnum[] = [
	'WATCHING_DESC',
	'STATUS_ASC',
	'NAME_ASC',
];
export const DEFAULT_TIMELINE_PROJECT_SORTS: ProjectSortEnum[] = ['START_DATE_ASC', 'NAME_ASC'];
